import React, { Fragment } from "react"
import { Popover, Tooltip } from "antd"
import { get, filter, some, uniq, uniqBy } from "lodash"
import checkIcon from "../../images/check-measure.svg"
import noResponse from "../../images/no-response.svg"
import ProgressBar from "../ProgressBar"

export const columns = (idStatus, measure, rowSelected, setStateFrom) => {
  if (measure.id_scope_type === 2) {
    return [
      {
        title: "Equipos",
        dataIndex: "full_name",
        key: "full_name",
        width: 320,
        sorter: (a, b) => {
          const aDivision = a.full_name || ""
          const bDivision = b.full_name || ""

          return aDivision.localeCompare(bDivision)
        },
        render: (text, record) => {
          if (!record.children) {
            return (
              <div className="measurement-columns-name">
                <div>
                  <span>
                    {record.survey_done ? (
                      <img src={checkIcon} />
                    ) : measure.id_measure_status === 5 ? (
                      <img src={noResponse} />
                    ) : (
                      "•"
                    )}
                  </span>
                  {record.full_name || `${record.first_name || ''} ${record.last_name || ''}`}{" "}
                  {record.email ? (
                    <Fragment>
                      - <span>{record.email} </span>
                    </Fragment>
                  ) : (
                    ""
                  )}
                </div>
                {/* <span>Líder</span> */}
              </div>
            )
          }

          return text
        },
      },
      {
        title: "Colaboradores",
        width: 140,
        dataIndex: "collaborators_quantity",
        key: "collaborators_quantity",
        render: (text, record) => {
          if (!record.children) return ""
          const answered = filter(record.children, (item) => !!item.survey_done)

          return (
            <div>
              <span style={{ color: "#979797" }}>{answered.length} / </span>
              {text}
            </div>
          )
        },
      },
      {
        title: "Segmento",
        width: 140,
        dataIndex: "segments",
        key: "segments",
        render: (text, record) => {
          /* (if (!record.children) return ""
          const answered = filter(record.children, (item) => !!item.survey_done) */

          return (
            <Tooltip
              title={uniqBy(record.segments, "id_segment")
                .map((item) => item.name)
                .join(", ")}>
              <div>
                {uniqBy(record.segments, "id_segment")
                  .map((item) => item.name)
                  .join(", ")}
              </div>
            </Tooltip>
          )
        },
      },
      {
        title: "Tasa de respuesta",
        width: 480,
        sorter: (a, b) => {
          // if (!a.document || !b.document) return;
          const aResponse = get(a, "rate.rate", 0) || 0
          const bResponse = get(b, "rate.rate", 0) || 0

          return aResponse - bResponse
        },
        render: (_, record) => {
          if (
            !record.children &&
            ![5].includes(idStatus) &&
            rowSelected.id_employee === record.id_employee
          ) {
            return (
              <div className="measurement-columns-response-rate__actions">
                {idStatus === 3 && record.email && record.survey_done === 0 && (
                    record.active_resend ? (
                      <Popover content={
                        <div style={{ maxWidth: 240 }}>
                          No es posible hacer más de un 1 reenvío en un plazo de{" "}
                          <strong>24 horas</strong>. La opción se habilitará nuevamente cuando el
                          plazo haya transcurrido.
                        </div>
                      } placement="topRight">
                        <span
                          className="color-blue hover-underline"
                          style={{
                            width: "60px",
                            marginRight: 15,
                            color: "rgba(0, 0, 0, 0.25)",
                            cursor: "no-drop",
                          }}>
                          Reenviar
                        </span>
                      </Popover>
                    ) : (
                      <span
                        className="color-blue hover-underline"
                        style={{
                          width: "60px",
                          marginRight: 15,
                          color: "#378FEE",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setStateFrom({
                            modalResendSurvey: true,
                            resendSurveyTo: record,
                          })
                        }}>
                        Reenviar
                      </span>
                    )
                )}
                <span
                  className="color-red hover-underline"
                  onClick={() => {
                    setStateFrom({
                      modalDeleteDivOrColl: true,
                      resendSurveyTo: record,
                    })
                  }}>
                  Eliminar
                </span>
              </div>
            )
          }

          if (record.children) {
            const value = get(record, "rate.rate", 0) || 0
            const color = get(record, "rate.rate_color", "red") || "red"
            const value_visible = get(record, "rate.rate_visible", "0%") || "0%"

            return (
              <div className="measurement-columns-response-rate">
                <ProgressBar
                  style={{ width: 320 }}
                  custom={{ color, value, value_visible }}
                />
              </div>
            )
          }
        },
      },
      {
        title: "Resultado",
        className:
          measure.id_measure_status === 5 ? "" : "hide-column-leaders-table",
        render: (_, record) => {
          const anonymity = get(record, "result.anonymity", false)
          if (!anonymity) {
            return <div>-</div>
          }
          if (!record.children) return ""
          const color = get(record, "result.color", "#EA6364") || "#EA6364"
          const value_visible =
            get(record, "result.value_visible", "0%") || "0%"

          return (
            <div
              style={{
                backgroundColor: color,
                color: "#FFF",
                borderRadius: 2,
                padding: "3px 0px",
                width: 48,
                textAlign: "center",
              }}>
              {value_visible}
            </div>
          )
        },
      },
    ]
  }

  return [
    {
      title: "Equipos",
      dataIndex: "full_name",
      key: "full_name",
      width: 320,
      sorter: (a, b) => {
        const aDivision = a.full_name || ""
        const bDivision = b.full_name || ""

        return aDivision.localeCompare(bDivision)
      },
      render: (text, record) => {
        if (!record.children) {
          return (
            <div className="measurement-columns-name">
              <div>
                <span>
                  {record.survey_done ? (
                    <img src={checkIcon} />
                  ) : measure.id_measure_status === 5 ? (
                    <img src={noResponse} />
                  ) : (
                    "•"
                  )}
                </span>
                {record.full_name}{" "}
                {record.email ? (
                  <Fragment>
                    - <span>{record.email} </span>
                  </Fragment>
                ) : (
                  ""
                )}
              </div>
              {/* <span>Líder</span> */}
            </div>
          )
        }

        return text
      },
    },
    {
      title: "Puesto",
      dataIndex: "position_name",
      key: "position_name",
      sorter: (a, b) => {
        // if (a.email || b.email) return;

        const aDivisionParent = a.position_name || ""
        const bDivisionParent = b.position_name || ""

        return aDivisionParent.localeCompare(bDivisionParent)
      },
      width: 240,
    },
    {
      title: "Colaboradores",
      width: 140,
      dataIndex: "collaborators_quantity",
      key: "collaborators_quantity",
      render: (text, record) => {
        if (!record.children) return ""
        const answered = filter(record.children, (item) => !!item.survey_done)

        return (
          <div>
            <span style={{ color: "#979797" }}>{answered.length} / </span>
            {text}
          </div>
        )
      },
    },
    {
      title: "Tasa de respuesta",
      width: 480,
      sorter: (a, b) => {
        // if (!a.document || !b.document) return;
        const aResponse = get(a, "rate.rate", 0) || 0
        const bResponse = get(b, "rate.rate", 0) || 0

        return aResponse - bResponse
      },
      render: (_, record) => {
        if (
          !record.children &&
          ![5].includes(idStatus) &&
          rowSelected.id_employee === record.id_employee
        ) {
          return (
            <div className="measurement-columns-response-rate__actions">
              {idStatus === 3 && record.email && record.survey_done === 0 && (
                record.active_resend ? (
                  <Popover content={
                    <div style={{ maxWidth: 240 }}>
                      No es posible hacer más de un 1 reenvío en un plazo de{" "}
                      <strong>24 horas</strong>. La opción se habilitará nuevamente cuando el
                      plazo haya transcurrido.
                    </div>
                  } placement="topRight">
                    <span
                      className="color-blue hover-underline"
                      style={{
                        width: "60px",
                        marginRight: 15,
                        color: "rgba(0, 0, 0, 0.25)",
                        cursor: "no-drop",
                      }}>
                      Reenviar
                    </span>
                  </Popover>
                ) : (
                  <span
                    className="color-blue hover-underline"
                    style={{
                      width: "60px",
                      marginRight: 15,
                      color: "#378FEE",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStateFrom({
                        modalResendSurvey: true,
                        resendSurveyTo: record,
                      })
                    }}>
                    Reenviar
                  </span>
                )
              )}
              <span
                className="color-red hover-underline"
                onClick={() => {
                  setStateFrom({
                    modalDeleteDivOrColl: true,
                    resendSurveyTo: record,
                  })
                }}>
                Eliminar
              </span>
            </div>
          )
        }

        if (record.children) {
          const value = get(record, "rate.rate", 0) || 0
          const color = get(record, "rate.rate_color", "red") || "red"
          const value_visible = get(record, "rate.rate_visible", "0%") || "0%"

          return (
            <div className="measurement-columns-response-rate">
              <ProgressBar
                style={{ width: 320 }}
                custom={{ color, value, value_visible }}
              />
              {/* TODO: Oculto temporalmente - Acciones para líderes
              {![5].includes(idStatus) &&
                rowSelected.id_employee === record.id_employee && (
                  <div className="measurement-columns-response-rate__actions">
                    {idStatus === 3 && some(record.children, (item) => item.email) && (
                      <span
                        className="color-blue hover-underline"
                        style={{
                          width: "60px",
                          marginRight: 15,
                          color: record.active_resend
                            ? "rgba(0, 0, 0, 0.25)"
                            : "#378FEE",
                          cursor: record.active_resend ? "no-drop" : "pointer",
                        }}
                        onClick={() => {
                          if (!record.active_resend) {
                            setStateFrom({
                              modalResendSurvey: true,
                              resendSurveyTo: record,
                            })
                          }
                        }}>
                        {value < 100 && "Reenviar"}
                      </span>
                    )}
                    <span
                      className="color-red hover-underline"
                      onClick={() => {
                        setStateFrom({
                          modalDeleteDivOrColl: true,
                          resendSurveyTo: record,
                        })
                      }}>
                      Eliminar
                    </span>
                  </div>
                )}
              */}
            </div>
          )
        }
      },
    },
    {
      title: "Resultado",
      className:
        measure.id_measure_status === 5 ? "" : "hide-column-leaders-table",
      render: (_, record) => {
        const anonymity = get(record, "result.anonymity", true)
        if (!anonymity) {
          return <div>-</div>
        }
        if (!record.children) return ""
        const color = get(record, "result.color", "#EA6364") || "#EA6364"
        const value_visible = get(record, "result.value_visible", "0%") || "0%"

        return (
          <div
            style={{
              backgroundColor: color,
              color: "#FFF",
              borderRadius: 2,
              padding: "3px 0px",
              width: 48,
              textAlign: "center",
            }}>
            {value_visible}
          </div>
        )
      },
    },
  ]
}
